<template>
    <tailwind-layout title="Lease Agreements">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden lg:flex justify-between items-center"><!-- Block for lg and larger -->
                <div class="flex flex-col">
                    <h1 class="font-semibold text-2xl leading-tight">Lease Agreements</h1>
                    <h2 class="text-xs">Visit Lawdepot to create a state-specific lease agreement.</h2>
                </div>
            </div>

            <div class="mb-3 px-6 lg:px-8 mx-auto flex flex-col lg:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex justify-between items-start md:items-center">
                    <div class="flex flex-col">
                        <h1 class="font-semibold text-2xl leading-tight">Lease Agreements</h1>
                        <h2 class="text-xs">Visit Lawdepot to create a state-specific lease agreement.</h2>
                    </div>
                </div>
            </div>
        </template>
        <div class="overflow-hidden">
            <div class="rounded-md shadow overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="overflow-hidden bg-white ring-1 ring-gray-200 p-6 flex flex-col md:flex-row justify-between gap-6">
                                <!-- Left Section -->
                                <div class="md:w-1/2 space-y-4">
                                    <h2 class="text-xl font-semibold text-gray-800">Why Require a Lease Agreement?</h2>
                                    <p class="text-gray-600">
                                        Creating a Residential Lease Agreement protects both parties when renting a residential property. A valid written agreement is legally binding and holds both parties accountable. 
                                    </p>
                                    <ul class="list-disc pl-5 text-gray-600 space-y-1">
                                    <li>Provides a clear legal framework</li>
                                    <li>Sets clear expectations</li>
                                    <li>Dispute resolution</li>
                                    <li>Stronger landlord-tenant relationship</li>
                                    </ul>
                                    <p class="text-gray-600">
                                        We encourage you to consider adding a lease agreement for a better leasing experience.
                                    </p>
                                </div>

                                <!-- Right Section -->
                                <div class="md:w-1/2 bg-gray-50 border border-gray-200 rounded-xl p-6 flex flex-col items-center text-center space-y-4">
                                    <p class="text-sm font-semibold text-gray-500 tracking-wide">POWERED BY</p>
                                    <img :src="appUrl('/lawdepot.png')" alt="LawDepot Logo" class="rounded-lg bg-white ring-1 ring-gray-900/10 p-2 w-20">
                                    
                                    <p class="text-gray-600">
                                        Need a rental agreement? We’ve partnered with Lawdepot to offer state-specific leases. Click this link to start building your custom lease:
                                    </p>
                                    
                                    <div class="w-full">
                                        <input 
                                            type="text" 
                                            id="lawdepot-link" 
                                            :value="lawdepot_url" 
                                            readonly 
                                            @click="copyToClipboard"
                                            class="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-gray-100 focus:outline-none cursor-pointer hover:bg-gray-200 transition-colors duration-200"
                                        >
                                        
                                        <!-- Copy notification -->
                                        <div v-if="showCopyNotification" class="mt-2 p-2 bg-green-100 border border-green-300 rounded-md text-sm text-green-700 text-center animate-pulse">
                                            {{ copyNotificationText }}
                                        </div>
                                    </div>
                                    
                                    <a
                                        target="_blank"
                                        :href="lawdepot_url"
                                        class="primaryButton"
                                    >
                                        Create a Lease
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from "@/Layouts/TailwindLayout.vue";
import Button from "@/Jetstream/Button.vue";

export default {
    components: {
        Button,
        TailwindLayout
    },
    props: {
        lawdepot_url: String
    },
    data() {
        return {
            showCopyNotification: false,
            copyNotificationText: ''
        }
    },
    watch: {

    },
    methods: {
        async copyToClipboard() {
            try {
                await navigator.clipboard.writeText(this.lawdepot_url);
                this.showSuccessNotification('URL copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy URL: ', err);
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = this.lawdepot_url;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.showSuccessNotification('URL copied to clipboard!');
                } catch (fallbackErr) {
                    console.error('Fallback copy failed: ', fallbackErr);
                    this.showErrorNotification('Failed to copy URL');
                }
                document.body.removeChild(textArea);
            }
        },
        showSuccessNotification(message) {
            this.copyNotificationText = message;
            this.showCopyNotification = true;
            setTimeout(() => {
                this.showCopyNotification = false;
            }, 3000);
        },
        showErrorNotification(message) {
            this.copyNotificationText = message;
            this.showCopyNotification = true;
            setTimeout(() => {
                this.showCopyNotification = false;
            }, 3000);
        },
    },
}
</script>
